// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:02Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Service pro práci se soubory dokumentu. Generated from cz.marbes.api.dokument.SouborService.
 */
export default class SouborApi {
    /**
     * Vytvoří obraz dokumentu ze šablony
     *
     * @param filename název souboru
     * @param kodSablona kód šablony
     * @param data data datový zdroj (klíč v mapě = jméno mergefieldu v šabloně, hodnota = vyhodnocená položka)
     * @return vytvořený resource (bez vazby na DB)
     */
    static buildObrazDokumentu(filename : string, kodSablona : string, data : {[key: string]: Object}) : String {
        const uri = serverContextPath + `/api/dokumenty/obraz/build`;
        const params = { filename, kodSablona,  };
        return generateUrl(uri, params, true);
    }

    /**
     * Aktualizuje soubor dokumentu.
     *
     * @param dokumentSouborId ID souboru dokumentu
     * @param file resource souboru
     */
    static updateDokumentSoubor(dokumentSouborId : number, file : Resource) {
        const uri = serverContextPath + `/api/soubory/${dokumentSouborId}/update`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, file, headers));
    }

    /**
     * Metoda pro získání hlavního obrazu dokumentu.
     *
     * @param dokumentId ID dokumentu, ze kterého se vrátí hlavní soubor
     * @param cisloVerze číslo verze hlavního souboru dokumentu
     * @return {@link InputStream} obrazu dokumentu
     */
    static getObrazHlavnihoDokumentu(dokumentId : number, cisloVerze : string) : String {
        const uri = serverContextPath + `/api/dokumenty/${dokumentId}/soubory/hlavni/stream`;
        const params = { cisloVerze };
        return generateUrl(uri, params, true);
    }

    /**
     * Přidá (uloží do DMS) obraz k předanému dokumentu. Pokud se bude jednat o první obraz nastaví na dokumentu vazbu hlavní soubor.
     *
     * @param dokumentId 
     * @param file resource souboru
     * @return uložený {@link DokumentSoubor}
     */
    static pridejObrazDokumentu(dokumentId : number, file : Resource) : Promise<DokumentSoubor> {
        const uri = serverContextPath + `/api/dokumenty/${dokumentId}/soubor/add`;
        const headers = new Headers();
        headers.append("Content-Type", "multipart/form-data");
        const params = undefined;
        const data = new FormData();
        data.append("file", file);
 
        return ErrorApi.responseResolver(ParamsFetch.post(uri, params, data, headers));
    }

    /**
     * Podepíše PDF dokument, předanýcm hashe. Pokud došlo mezi voláním této metody a metody {@link #vratHashPdfDokumentu(Integer, Resource)} k restartu aplikačního serveru, byla ztracena reference na dokument a je vyhozena vyjimka.
     *
     * @param dokumentSouborId ID souboru dokumentu
     * @param signedHash podepsaný hash
     * @param timeStamp příznak zda přidat časové razítko
     */
    static vlozPodepsanyHashDoPdf(dokumentSouborId : number, signedHash : Resource, timeStamp : boolean) {
        const uri = serverContextPath + `/api/soubory/${dokumentSouborId}/vloz/podepsany/hash`;
        const headers = undefined;
        const params = { timeStamp };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, signedHash, headers));
    }

    /**
     * Přidá (uloží do DMS) obraz k předanému dokumentu. Výsledný soubor se bude odkazovat na obraz dokumentu zdrojového souboru. Pokud se bude jednat o první obraz nastaví na dokumentu vazbu hlavní soubor.
     *
     * @param dokumentId 
     * @param zdrojSouborId 
     * @return uložený {@link DokumentSoubor}
     */
    static pridejObrazDokumentuOdkazem(dokumentId : number, zdrojSouborId : number) : Promise<DokumentSoubor> {
        const uri = serverContextPath + `/api/dokumenty/${dokumentId}/soubor/addlinked`;
        const headers = undefined;
        const params = { zdrojSouborId };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Vrátí soubor dokumentu s předaným ID.
     *
     * @param id ID souboru dokumentu
     * @return soubor dokumentu
     */
    static getDokumentSouborById(id : number) : Promise<DokumentSoubor> {
        const uri = serverContextPath + `/api/soubory/${id}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Smaže soubor dokumentu. <p> Aktuálně je podporováno pouze smazání souboru, který není v rámci dokumentu hlavní.
     *
     * @param dokumentSouborId ID souboru dokumentu
     */
    static deleteDokumentSoubor(dokumentSouborId : number) {
        const uri = serverContextPath + `/api/soubory/${dokumentSouborId}/delete`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Vrátí hlavNí soubor dokumentu s předaným ID.
     *
     * @param dokumentId ID dokumentu
     * @return hlavní soubor dokumentu
     */
    static getHlavniDokumentSoubor(dokumentId : number) : Promise<DokumentSoubor> {
        const uri = serverContextPath + `/api/dokumenty/${dokumentId}/soubory/hlavni`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vytvoří/přidá (uloží do DMS) obraz k předanému dokumentu ze šablony.
     *
     * @param dokumentId 
     * @param kodSablona kód šablony
     * @param data datový zdroj (klíč v mapě = jméno mergefieldu v šabloně, hodnota = vyhodnocená položka)
     * @return uložený {@link DokumentSoubor}
     */
    static createObrazDokumentu(dokumentId : number, kodSablona : string, data : {[key: string]: Object}) : Promise<DokumentSoubor> {
        const uri = serverContextPath + `/api/dokumenty/${dokumentId}/soubory/obraz/create`;
        const headers = undefined;
        const params = { kodSablona,  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, data, headers));
    }

    /**
     * Vypočte a vrátí hash PDF dokumentu k podpisu. Pro výpočet je použita metoda SHA1.
     *
     * @param dokumentSouborId ID souboru dokumentu
     * @param encodedCert public key k certifikátu (je potřeba pro inicializaci viditelneho podpisu, pokud je {@code null} podpis nebude viditelný)
     * @return hash pdf dokumentu
     */
    static vratHashPdfDokumentu(dokumentSouborId : number, encodedCert : Resource) : String {
        const uri = serverContextPath + `/api/soubory/${dokumentSouborId}/vrat/hash`;
        const params = {  };
        return generateUrl(uri, params, true);
    }

    /**
     * Dle nastavení v cz.marbes.dok.domain.gen.DokTypDokumentGen podepíše dokument systémovým certifikátem anebo časovým razítkem. Převede soubor do formátu PDF pokud již není.
     *
     * @param dokumentSouborId ID souboru dokumentu
     * @param finParams params parametry finalizace
     */
    static finalizujDokumentSoubor(dokumentSouborId : number, finParams : FinalizaceParams) {
        const uri = serverContextPath + `/api/soubory/${dokumentSouborId}/finalizuj`;
        const headers = undefined;
        const params = { finParams };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Zkonvertuje soubor do PDF. <ul> <li>Dokument vyzvedne z DMS</li> <li>Provede konverzi nakonfigurovaným RTF2PDF konektorem</li> <li>Vrátí do DMS zkonvertovaný/nový obraz</li> </ul>
     *
     * @param dokumentSouborId 
     * @return aktualizovaný soubor
     */
    static konvertujDoPdf(dokumentSouborId : number) : Promise<DokumentSoubor> {
        const uri = serverContextPath + `/api/soubory/${dokumentSouborId}/konvertuj/pdf`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Metoda pro získání obrazu dokumentu.
     *
     * @param dokumentSouborId ID souboru, jehož stream chceme získat
     * @param cisloVerze číslo verze souboru dokumentu
     * @return {@link InputStream} obrazu dokumentu
     */
    static getObrazDokumentu(dokumentSouborId : number, cisloVerze : string) : String {
        const uri = serverContextPath + `/api/soubory/${dokumentSouborId}/stream`;
        const params = { cisloVerze };
        return generateUrl(uri, params, true);
    }

    /**
     * Najde soubory dokumentů s předanými ID.
     *
     * @param ids množina ID souborů dokumentů
     * @return nalezené soubory dokuemntů
     */
    static findDokumentSouborByIds(ids : number[]) : Promise<DokumentSoubor[]> {
        const uri = serverContextPath + `/api/soubory/batchRequest`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, ids, headers));
    }

    /**
     * Metoda pro získání náhledu hlavního obrazu dokumentu.
     *
     * @param dokumentId ID dokumentu, jehož náhled hlavní soubor chceme získat
     * @param cisloVerze číslo verze hlavního souboru dokumentu
     * @param maxWidth maxiální šířka náhledu, pokud není uvedeno, musí být uvedena alespoň maxHeight
     * @param maxHeight maxiální výška náhledu, pokud není uvedeno, musí být uvedena alespoň maxWidth
     * @param backgroundColor pokud má vstupní obraz průhledné části, budou vyplněny touto barvou. Pokud nebude předána použije se bílá barva
     * @return náhled obrazu dokumentu, nebo {@code null} pokud se náhled nepodaří vytvořit
     */
    static getNahledObrazHlavnihoDokumentu(dokumentId : number, cisloVerze : string, maxWidth : number, maxHeight : number, backgroundColor : Color) : String {
        const uri = serverContextPath + `/api/dokumenty/${dokumentId}/soubory/hlavni/nahled/stream`;
        const params = { cisloVerze, maxWidth, maxHeight, backgroundColor };
        return generateUrl(uri, params, true);
    }

    /**
     * Metoda pro získání náledu pro obraz dokumentu.
     *
     * @param dokumentSouborId ID souboru, jehož náhled chceme získat
     * @param cisloVerze číslo verze souboru dokumentu
     * @param maxWidth maxiální šířka náhledu, pokud není uvedeno, musí být uvedena alespoň maxHeight
     * @param maxHeight maxiální výška náhledu, pokud není uvedeno, musí být uvedena alespoň maxWidth
     * @param backgroundColor pokud má vstupní obraz průhledné části, budou vyplněny touto barvou. Pokud nebude předána použije se bílá barva
     * @return náhled obrazu dokumentu, nebo {@code null} pokud se náhled nepodaří vytvořit
     */
    static getNahledObrazDokumentu(dokumentSouborId : number, cisloVerze : string, maxWidth : number, maxHeight : number, backgroundColor : Color) : String {
        const uri = serverContextPath + `/api/soubory/${dokumentSouborId}/nahled/stream`;
        const params = { cisloVerze, maxWidth, maxHeight, backgroundColor };
        return generateUrl(uri, params, true);
    }

}